module.exports = __webpack_public_path__ + "static/media/ChooseAttack Vector.3cf1df35.png";